import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
    useEffect(() => { document.title = "Page not found — AccessNova"; }, []);

    return (
        <section aria-labelledby="nf-heading" className="py-24 lg:py-32">
            <div className="mx-auto max-w-2xl px-4 text-center">
                <p className="text-sm font-semibold uppercase tracking-wider text-brand-teal">404</p>
                <h1 id="nf-heading" className="mt-3 text-5xl sm:text-6xl font-bold text-brand-text">
                    We couldn't find that page.
                </h1>
                <p className="mt-5 text-lg text-brand-body">
                    The link may be broken or the page has moved. Let's get you back on track.
                </p>
                <Link
                    to="/"
                    className="mt-8 inline-flex items-center gap-2 rounded-md bg-brand-navy text-white font-semibold px-6 py-3 hover:bg-brand-teal transition-colors touch-target"
                    data-testid="notfound-back-home"
                >
                    <HomeIcon size={18} aria-hidden="true" />
                    Back to homepage
                </Link>
            </div>
        </section>
    );
}
